import { Fragment, useMemo } from 'react';
import { CSSTransition } from 'react-transition-group';
import { useEffectOnce } from 'react-use';
import { rage, useObservable } from '~/rage';
import { RockPaperScissorsGameStatus } from '~/shared';
import { Game } from '../../components/Game';
import { ResultOverlay } from '../../components/ResultOverlay';
import { Waiting } from '../../components/Waiting';
import { resetStore, useLayoutDispatch } from '../../redux';

const RockPaperScissors = () => {
	const status = useObservable(rage.rockPaperScissors.getStatus());
	const dispatch = useLayoutDispatch();

	const resultOverlayVisible = useMemo(() => {
		return (
			status === RockPaperScissorsGameStatus.WON ||
			status === RockPaperScissorsGameStatus.LOST ||
			status === RockPaperScissorsGameStatus.DRAW
		);
	}, [status]);

	useEffectOnce(() => {
		return () => {
			dispatch(resetStore());
		};
	});

	return (
		<Fragment>
			{status === RockPaperScissorsGameStatus.PLAYING && <Game />}
			<CSSTransition
				in={resultOverlayVisible}
				timeout={300}
				classNames="fade"
				unmountOnExit
			>
				<ResultOverlay />
			</CSSTransition>
			<CSSTransition
				in={status === RockPaperScissorsGameStatus.WAITING}
				timeout={300}
				classNames="fade"
				unmountOnExit
				appear
			>
				<Waiting />
			</CSSTransition>
		</Fragment>
	);
};

export { RockPaperScissors };
